import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../../components/default/header";
import MockupForm from "./mockupform";
import SingleSidebarMenu from "../../../business/menu/singleSidebarMenu";
import Breadcrumb from "../../../default/breadcrumb/breadcrumb";

const CreateMockup = () => {
    return (
        <div className="business-wrapper sidebar-menu-enable menu-with-settings">
        <Helmet><title>Create Mockup</title></Helmet>
        <Header />
        <div className="sidebar-with-content ds-flex">
             <SingleSidebarMenu />
            <div className="content-right">
                <Breadcrumb />
                <div class="connection-header">
                    <h3>New Mockup</h3>
                </div>
                <MockupForm />
            </div>
        </div>
    </div>
    );
}

export default CreateMockup;